import { createContext, } from 'react';
import { types } from './constants';
export const defaultContext = {
    controlType: types.compact,
    currentPageNumber: 1,
    hasViewAllLink: false,
    isViewAllActive: false,
    makeHref: undefined,
    onNextClick: () => { },
    onPageClick: undefined,
    onPrevClick: () => { },
    onViewAllClick: () => { },
    onViewLessClick: () => { },
    totalPages: 1,
};
export const PaginationContext = createContext(defaultContext);
